/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import {AnalyticsService} from './@core/utils/analytics.service';
import {SeoService} from './@core/utils/seo.service';
import {InternalService} from './services/internal.service';
import {NbLayoutDirection, NbLayoutDirectionService} from '@nebular/theme';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { ApiService } from './services/api.service';
import { UserService } from './@core/mock/users.service';


@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService,
              private directionService: NbLayoutDirectionService,
              public translate: TranslateService,
              private title: Title,
              public apiService: ApiService,
              public userService: UserService,
              public internalService: InternalService) {
                if(!localStorage.getItem('lang')){
                  this.apiService.getMyIP().subscribe((response: any) => {
                    if (response.stu==0 || response.res!='IR'){
                      this.internalService.changeLang('en-us', 0);
                      this.directionService.setDirection(NbLayoutDirection.LTR); // English is default for the first time and for the other countries
                    }
                    else{
                      this.internalService.changeLang('fa-ir', 0); // Persian
                    }
                  });
                }   
                else{
    if (localStorage.getItem('lang') === '1') {
      this.internalService.changeLang('fa-ir', 0);
    } else {
      this.internalService.changeLang('en-us', 0);
      this.directionService.setDirection(NbLayoutDirection.LTR);
    }
  }
    this.translate.get('Doris').subscribe(res => {
      this.title.setTitle(res);
    });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    // this.apiService.getMenus().subscribe((response: any) => {
    //   this.apiService.userInfo=response.res;
    //   console.log(this.apiService.userInfo)
    //   for(let item of response.res.userMenu){
    //     this.apiService.routePath.push(item.key.toLowerCase());
    //   }
    // });
  }
}
